import { Fade } from '@mui/material';
import useWorkspaceMassActionsStore from '../../../../../../stores/WorkspaceMassActions/workspaceMassActions.store';
import MassActionsBar from '../../../MassActionsBar/MassActionsBar';
import { useWorkspaceMassActionsSlotStyles } from './workspaceMassActionsSlot.styles';

export function WorkspaceMassActionsSlot() {
  const config = useWorkspaceMassActionsStore((state) => state.config);
  const { classes } = useWorkspaceMassActionsSlotStyles();

  return (
    <Fade in={config !== null} unmountOnExit>
      <div className={classes.shell}>
        {config && ('content' in config ? config.content : <MassActionsBar {...config} />)}
      </div>
    </Fade>
  );
}
